import { useTheme } from '@/contexts/ThemeContext';

const segments = [
  {
    icon: 'ri-graduation-cap-line',
    title: 'Instituições de Ensino',
    description: 'Escolas, colégios e faculdades que precisam de gestão acadêmica, financeira e comunicação integrada com alunos e responsáveis.',
    image: 'https://readdy.ai/api/search-image?query=modern%20school%20management%20software%20dashboard%20interface%20with%20dark%20navy%20theme%2C%20student%20records%2C%20academic%20calendar%2C%20grade%20management%2C%20professional%20UI%20design%2C%20clean%20corporate%20software%20screenshot&width=400&height=260&seq=seg-escola-01&orientation=landscape',
  },
  {
    icon: 'ri-recycle-line',
    title: 'Empresas de Reciclagem',
    description: 'Cooperativas e empresas de reciclagem que precisam controlar entrada de materiais, pesagem, fornecedores e relatórios de produção.',
    image: 'https://readdy.ai/api/search-image?query=recycling%20company%20ERP%20management%20system%20dashboard%20with%20dark%20theme%2C%20material%20control%2C%20weight%20tracking%2C%20inventory%20management%2C%20professional%20software%20interface%2C%20clean%20UI&width=400&height=260&seq=seg-recicl-01&orientation=landscape',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Indústrias',
    description: 'Indústrias de médio e grande porte que necessitam de controle de produção, estoque, qualidade, manutenção e integração com chão de fábrica.',
    image: 'https://readdy.ai/api/search-image?query=industrial%20ERP%20system%20dashboard%20with%20dark%20navy%20blue%20theme%2C%20production%20control%2C%20inventory%20management%2C%20quality%20control%20charts%2C%20professional%20manufacturing%20software%20interface&width=400&height=260&seq=seg-ind-01&orientation=landscape',
  },
  {
    icon: 'ri-truck-line',
    title: 'Distribuidoras',
    description: 'Distribuidoras e atacadistas que precisam de controle de pedidos, rotas de entrega, gestão de estoque e integração com força de vendas.',
    image: 'https://readdy.ai/api/search-image?query=distribution%20company%20ERP%20dashboard%20with%20dark%20theme%2C%20order%20management%2C%20delivery%20routes%2C%20inventory%20control%2C%20sales%20force%20management%2C%20professional%20logistics%20software%20interface&width=400&height=260&seq=seg-dist-01&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'Prestadores de Serviço',
    description: 'Empresas de serviços que precisam de gestão de ordens de serviço, contratos, equipes técnicas, faturamento e relacionamento com clientes.',
    image: 'https://readdy.ai/api/search-image?query=service%20company%20management%20software%20dashboard%20dark%20theme%2C%20work%20orders%2C%20contract%20management%2C%20team%20scheduling%2C%20billing%20system%2C%20professional%20CRM%20interface%20clean%20UI&width=400&height=260&seq=seg-serv-01&orientation=landscape',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Empresas com ERP Personalizado',
    description: 'Negócios com processos únicos que os ERPs de prateleira não atendem. Desenvolvemos do zero, com total aderência ao seu fluxo operacional.',
    image: 'https://readdy.ai/api/search-image?query=custom%20ERP%20enterprise%20software%20dashboard%20dark%20navy%20theme%2C%20business%20intelligence%2C%20custom%20reports%2C%20KPI%20metrics%2C%20financial%20analytics%2C%20professional%20corporate%20software%20interface&width=400&height=260&seq=seg-erp-01&orientation=landscape',
  },
];

export default function Segments() {
  const { isDark } = useTheme();

  return (
    <section
      id="segmentos"
      className={`py-28 transition-colors duration-500 ${isDark ? 'bg-[#060b18]' : 'bg-slate-50'}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16 gap-4">
          <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border ${
            isDark ? 'border-cyan-500/30 bg-cyan-500/10' : 'border-cyan-400/40 bg-cyan-50'
          }`}>
            <i className="ri-focus-3-line text-cyan-500 text-sm"></i>
            <span className="text-cyan-600 text-xs font-semibold tracking-widest uppercase">Segmentos Atendidos</span>
          </div>
          <h2 className={`text-3xl lg:text-5xl font-bold leading-tight ${isDark ? 'text-white' : 'text-slate-900'}`}>
            Especialistas em{' '}
            <span className="bg-gradient-to-r from-cyan-500 to-cyan-400 bg-clip-text text-transparent">
              múltiplos setores
            </span>
          </h2>
          <p className={`text-lg max-w-2xl ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
            Cada segmento tem suas particularidades. Desenvolvemos sistemas que entendem profundamente o seu negócio e entregam soluções que realmente funcionam.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {segments.map((seg) => (
            <div
              key={seg.title}
              className={`group rounded-2xl overflow-hidden border transition-all duration-300 cursor-pointer ${
                isDark
                  ? 'border-white/8 bg-[#0d1526] hover:border-cyan-500/30'
                  : 'border-slate-200 bg-white hover:border-cyan-400/50'
              }`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={seg.image}
                  alt={seg.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${
                  isDark ? 'from-[#0d1526] via-[#0d1526]/40 to-transparent' : 'from-white/80 via-white/20 to-transparent'
                }`}></div>
                <div className={`absolute bottom-4 left-4 w-10 h-10 flex items-center justify-center rounded-lg ${
                  isDark ? 'bg-cyan-500/20 border border-cyan-500/30' : 'bg-white border border-cyan-200'
                }`}>
                  <i className={`${seg.icon} text-cyan-500 text-lg`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className={`text-lg font-bold mb-2 ${isDark ? 'text-white' : 'text-slate-900'}`}>{seg.title}</h3>
                <p className={`text-sm leading-relaxed ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>{seg.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
